// extracted by mini-css-extract-plugin
module.exports = {"otherPageLink":"otherPageLink","otherPageLink__title":"otherPageLink__title","otherPageLink__list":"otherPageLink__list"};